export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?hl=id&id=id.tries.kiriminaja'
export const APP_STORE_URL =
  'https://apps.apple.com/id/app/kiriminaja/id1544207424'
export const WEB_APP_URL = 'https://app.kiriminaja.com'
export const COMPANY_ADDRESS =
  'Jl. Palagan Tentara Pelajar No.77, Mudal, Sariharjo, Kec. Ngaglik, Kabupaten Sleman, Daerah Istimewa Yogyakarta'
export const hotlineWhatsappNumber = '6281125209900'
export const FIREBASE_DYNAMIC_LINK =
  'https://kiriminaja.page.link?amv=1&apn=id.tries.kiriminaja&ibi=id.tries.kiriminaja&imv=1&isi=1544207424&link=https%3A%2F%2Fkiriminaja.page.link.com%2F%3Fpage%3D'
